import $ from 'jquery';

class Search{

    constructor(){

        this.addSearchHTML();

        this.resultsDiv = $('#search-overlay__results');

        this.openButton = $("#search-trigger");

        this.searchIcon = $(".search-overlay__icon");

        this.closeButton = $(".search-overlay__close");

        this.searchOverlay = $(".search-overlay");

        this.searchField = $("#search-term");

        this.isOverlayOpen = false;

        this.isSpinnerVisible = false;

        this.previousValue;

        this.typingTimer;

        this.searchIcon.html(this.createSearchIcon( ));
        
        this.events();
    }

    events(){

        this.openButton.on('click', this.openOverlay.bind(this));

        this.closeButton.on('click', this.closeOverlay.bind(this));

        this.searchField.on('keyup', this.typingLogic.bind(this));

        $(document).on('keydown', this.keyPressDispatcher.bind(this));
        
    }

    typingLogic(){

        if(this.searchField.val() != this.previousValue){

            clearTimeout(this.typingTimer);

            if(this.searchField.val() && this.searchField.val().length > 2){

                if(!this.isSpinnerVisible){
                    
                    this.resultsDiv.html('<div class="busy-spinner-dark"></div>');
        
                    this.isSpinnerVisible = true;
                }
        
                this.typingTimer = setTimeout(this.getResults.bind(this), 650);

            }else{

                this.resultsDiv.html('');

                this.isSpinnerVisible = false;

            }

        }

        this.previousValue = this.searchField.val();
        
    }

    getResults(){

        var searchTerm = this.searchField.val();


        $.getJSON(`${jpfData.root_url}/wp-json/jpf/v1/search?term=${searchTerm}`, (results) => {

            this.resultsDiv.html(`

                <div class="search-overlay__section">
                    <h2 class="search-overlay__section-title">General Information</h2>
                    ${results.generalInfo.length ? '<ul>': '<p>No general information matches that search.</p>'}
                    
                        ${results.generalInfo.map(item => `<li><a href="${item.permalink}">${item.title}</a> ${ item.postType =='post' ? `by ${item.authorName}`: '' }</li>`).join('')}
        
                    ${results.generalInfo.length ? '</ul>': ''} 
                </div>

                <div class="search-overlay__section">
                    <h2 class="search-overlay__section-title">Distribution</h2>
                    ${results.distribution.length ? '<ul>': `<p>No distribution category matches that search. <a href="${jpfData.root_url}/distribution">View all distribution.</a></p>`}
                    
                        ${results.distribution.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
        
                    ${results.distribution.length ? '</ul>': ''} 
                </div>

                <div class="search-overlay__section">
                    <h2 class="search-overlay__section-title">Ready Meals</h2>
                    ${results.readyMeals.length ? '<ul>': `<p>No ready meals matches that search. <a href="${jpfData.root_url}/ready-meals">View all ready meals.</a></p>`}
                    
                        ${results.readyMeals.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
        
                    ${results.readyMeals.length ? '</ul>': ''} 
                </div>

                <div class="search-overlay__section">
                    <h2 class="search-overlay__section-title">Nomad Kitchens</h2>
                    ${results.nomadKitchens.length ? '<ul>': `<p>No nomad kitchens matches that search. <a href="${jpfData.root_url}/nomad-kitchens">View all nomad kitchens.</a></p>`}
                    
                        ${results.nomadKitchens.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
        
                    ${results.nomadKitchens.length ? '</ul>': ''} 
                </div>
                
                
            `);

            /* 
            this.resultsDiv.html(`


                <div class="row">

                  <div class="one-third">
                    <h2 class="search-overlay__section-title">General Information</h2>

                        ${results.generalInfo.length ? '<ul class="link-list min-list">': '<p>No general information match that search.</p>'}
                        
                            ${results.generalInfo.map(item => `<li><a href="${item.permalink}">${item.title}</a> ${ item.postType =='post' ? `by ${item.authorName}`: '' }</li>`).join('')}
            
                        ${results.generalInfo.length ? '</ul>': ''} 

                  </div>

                  <div class="one-third">
                    <h2 class="search-overlay__section-title">Programs</h2>

                        ${results.programs.length ? '<ul class="link-list min-list">': `<p>No programs match that search. <a href="${jpfData.root_url}/programs">View all programs</a></p>`}
                        
                            ${results.programs.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
            
                        ${results.programs.length ? '</ul>': ''} 

                    <h2 class="search-overlay__section-title">Professors</h2>

                        ${results.professors.length ? '<ul class="professor-cards">': `<p>No professors match that search.</p>`}
                        
                            ${results.professors.map(item => `
                                
                                <li class="professor-card__list-item">
                                    <a class="professor-card" href="${item.permalink}">
                                        <img src="${item.image}" alt="" class="professor-card__image">
                                        <span class="professor-card__name">${item.title}</span> 
                                    </a>
                                </li>

                            `).join('')}
            
                        ${results.professors.length ? '</ul>': ''} 

                  </div>

                  <div class="one-third">
                    <h2 class="search-overlay__section-title">Campuses</h2>

                        ${results.campuses.length ? '<ul class="link-list min-list">': `<p>No campuses match that search.  <a href="${jpfData.root_url}/campuses">View all campuses</a></p>`}
                        
                            ${results.campuses.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join('')}
            
                        ${results.campuses.length ? '</ul>': ''} 

                    <h2 class="search-overlay__section-title">Events</h2>

                        ${results.events.length ? '': `<p>No events match that search.  <a href="${jpfData.root_url}/events">View all events</a></p>`}
                        
                        ${results.events.map(item => `

                            <div class="event-summary">
                                <a class="event-summary__date t-center" href="${item.permalink}">
                                    <span class="event-summary__month">${item.month}</span>
                                    <span class="event-summary__day">${item.day}</span>
                                </a>
                                <div class="event-summary__content">
                                    <h5 class="event-summary__title headline headline--tiny"><a href="${item.permalink}">${item.title}</a></h5>
                                    <p>${item.description} <a href="${item.permalink}" class="nu gray">Learn more</a></p>
                                </div>
                            </div>                            
                            
                        `).join('')}

                  </div>

                </div>
               

            `); 
            */

            this.isSpinnerVisible = false;

        });

        
        
    }

    keyPressDispatcher(event){

        if(event.keyCode == 83 && !this.isOverlayOpen && !$("input, textarea").is(':focus')){

            this.openOverlay();

        }

        if(event.keyCode == 27 && this.isOverlayOpen ){

            this.closeOverlay();

        }
        
    }

    openOverlay(){

        this.isOverlayOpen = true;

        this.searchOverlay.addClass("search-overlay--active");

        //$("body").addClass("body-no-scroll");
       

        this.searchField.val('');

        this.resultsDiv.html('');

        setTimeout(()=> this.searchField.focus(), 301);
        
    }

    closeOverlay(){
        
        this.isOverlayOpen = false;

        this.searchOverlay.removeClass("search-overlay--active");

        //$("body").removeClass("body-no-scroll");
        
        
    }

    addSearchHTML(){
       
        $("body").append(`
            
            <div class="search-overlay">

                <div class="search-overlay__header">
                    <div class="input-wrapper">
                        <i class="search-overlay__icon" aria-hidden="true"></i>
                        <input type="text" id="search-term" placeholder="What are you looking for?" id="search-term" autocomplete="off">
                        <i class="search-overlay__close" aria-hidden="true" title="Close Search"></i>
                    </div>
                </div>
            
                <div class="search-overlay__content">
                    <div id="search-overlay__results">

                        <div class="search-overlay__section">
                            <h2 class="search-overlay__section-title">General Information</h2>
                            <ul class="link-list min-list">
                                <li><a href="#">Test Post</a></li>
                            </ul>
                        </div>
                        <div class="search-overlay__section">
                            <h2 class="search-overlay__section-title">Distribution</h2>
                            <ul class="link-list min-list">
                                <li><a href="#">Test Post</a></li>
                            </ul>
                        </div>
                        <div class="search-overlay__section">
                            <h2 class="search-overlay__section-title">Ready Meals</h2>
                            <ul class="link-list min-list">
                                <li><a href="#">Test Post</a></li>
                            </ul>
                        </div>
                        <div class="search-overlay__section">
                            <h2 class="search-overlay__section-title">Nomad Kitchens</h2>
                            <ul class="link-list min-list">
                                <li><a href="#">Test Post</a></li>
                            </ul>
                        </div>

                    </div>
                </div>
            
            </div>           
            
        `);

    }

    createSearchIcon( ){

        var html = `

            <svg viewBox="0 -960 960 960">
                <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 
                83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/>
            </svg>
        
        `;

        
        return html;
            
    }
}

export default Search;